export default __webpack_public_path__ + "static/media/viaje-seguro.67f292dc.svg";